export default {
  GET_OBECTS: (state) => state.obects,
  GET_WAREHOUSE: (state) => state.warehouse,
  GET_WAREHOUSE_SCROLL: (state) => state.warehouse_scroll,
  GET_WAREHOUSE_TABLE: (state) => state.warehouseTable,
  GET_WAREHOUSE_ID: (state) => state.warehouseId,
  GET_MODALE_WAREHOUSE: (state) => state.warehouseModale,
  GET_PIN_MODALE_WAREHOUSE: (state) => state.warehousePinModal,
};
